module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r5n1n2r-3fe5926c1d9530919779a4ec6ce3bf41.svg";